<template>
  <section class="marketing-sms-form-senders-external">
    <div v-if="hasExternalConfiguration && !showFileDropzone"
         class="marketing-sms-form-senders-external-list">
      <button type="button"
              class="marketing-sms-form-senders-external-list-change"
              @click="showDropzone">
        <i class="mdi mdi-plus"></i> {{$t('message.marketingGenerics.message.importNewFile')}}
      </button>
      <div class="marketing-sms-form-senders-external-list-data">
        <p class="marketing-sms-form-senders-external-list-data-title">{{$t('message.marketingGenerics.message.currentDataBase')}}</p>

        <v-data-table class="marketing-sms-form-senders-external-list-data-items"
                      :items="configuration"
                      :hide-actions="true"
                      :no-data-text="$t('message.marketingPlan.message.noPlansRegistered')"
                      :no-results-text="$t('message.generics.message.noData')"
                      hide-headers>

          <template slot="items"
                    slot-scope="props">
            <tr>
              <td>
                {{ props.item.key }}
              </td>
            </tr>
          </template>
        </v-data-table>

      </div>
    </div>

    <div class="marketing-sms-form-senders-external-dropzone">
      <dropzone v-if="showFileDropzone"
                :value="file"
                name="Arquivo de base externa"
                @input="emitFile" />

      <p class="marketing-sms-form-senders-external-dropzone-help">{{ helpText }}</p>
      <a class="marketing-sms-form-senders-external-dropzone-download text-primary"
         download
         :href="fileDownloadUrl">{{$t('message.marketingGenerics.message.downloadFileTemplate')}}</a>
    </div>

    <app-textarea class="marketing-sms-form-senders-external-source"
                  v-if="showSourceNoteField"
                  v-model="sourceNote"
                  :disabled="edit && !file"
                  validate="required"
                  :rows="4"
                  :minlength="5"
                  :maxlength="150"
                  :label="$t('message.marketingGenerics.message.dataOrigin')"
                  name="Origem dos dados"
                  outlined
                  no-rezise
                  :error-messages="errors.collect($t('message.marketingGenerics.message.dataOrigin'))"
                  @input="emitSourceNote">
    </app-textarea>
  </section>
</template>

<script>
import AppTextarea from "@components/form/Textarea.vue";
import Dropzone from "@components/form/Dropzone.vue";
import EventBus from "../../../../../../../packages/event-bus";

export default {
  components: {
    Dropzone,
    AppTextarea,
  },

  data() {
    return {
      showFileDropzone: true,
      sourceNote: undefined,
    };
  },

  props: {
    channelData: {
      type: Object,
      required: false,
    },
    channelType: {
      type: String,
      required: false,
    },
    file: {
      type: File,
      required: false,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  methods: {
    emitFile(file) {
      this.$emit("input", { file, sourceNote: this.sourceNote });
    },
    showDropzone() {
      this.$emit("fileMode");
      this.showFileDropzone = true;
    },
    emitSourceNote(val) {
      this.$emit("input", { file: this.file, sourceNote: val });
    },
  },

  mounted() {
    if (this.hasExternalConfiguration) {
      this.showFileDropzone = false;
    }

    if (this.edit) {
      this.sourceNote = this.channelData.sourceNote;
    }
  },

  beforeDestroy() {
    EventBus.$emit("external-has-not-changed")
  },

  computed: {
    hasExternalConfiguration() {
      return this.hasConfiguration && Array.isArray(this.configuration);
    },
    hasConfiguration() {
      return !!this.channelData && !!this.channelData.configuration;
    },
    configuration() {
      return (
        this.hasConfiguration && JSON.parse(this.channelData.configuration)
      );
    },
    showSourceNoteField() {
      return this.showFileDropzone ? !!this.file : this.edit || !!this.file;
    },
    fileDownloadUrl() {
      return this.channelType === "EMAIL"
        ? `${process.env.VUE_APP_BACK_END_URL}/file/public/static/email-external-example.csv`
        : `${process.env.VUE_APP_BACK_END_URL}/file/public/static/sms-external-example.csv`;
    },
    helpText() {
      return this.channelType === "EMAIL"
        ? this.$t('message.marketingGenerics.message.externalFileEmail')
        : this.$t('message.marketingGenerics.message.externalFileSms');
    },
  },

  mixins: [],
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.marketing-sms-form-senders-external {
  .marketing-sms-form-senders-external-list {
    .marketing-sms-form-senders-external-list-change {
      margin-left: auto;
      display: flex;
      align-items: center;
      color: $primary;
      padding-right: 0;
      font-size: 14px;
    }

    .marketing-sms-form-senders-external-list-data {
      border: 2px solid #c4c4c4;
      border-radius: 8px;
      margin-bottom: 20px;

      .marketing-sms-form-senders-external-list-data-title {
        margin-left: 24px;
        margin-top: 24px;
        font-weight: 600;
        text-align: center;
      }

      .marketing-sms-form-senders-external-list-data-items {
        max-height: 300px;
        overflow-y: auto;
      }
    }
  }

  .marketing-sms-form-senders-external-dropzone {
    margin-bottom: 20px;
    text-align: center;

    .marketing-sms-form-senders-external-dropzone-help {
      font-size: 15px;
      color: #707070;
      margin: 0;
    }

    .marketing-sms-form-senders-external-dropzone-download {
      margin: 0;
      font-size: 15px;
      color: $primary;
      cursor: pointer;
    }
  }

  .marketing-sms-form-senders-external-source {
    width: 100%;
    margin-bottom: 8px;

    ::v-deep .v-input__control {
      flex: 1;
    }
  }
}
</style>
